var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(Array.isArray(_vm.releasesOnProdData))?_c('deployment-frequency',{attrs:{"releasesOnProdData":_vm.releasesOnProdData,"fontSize":_vm.fontSize}}):_c('ReloadIcon'),_c('lead-time',{attrs:{"fontSize":_vm.fontSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }